import { CardOption } from "@/components/ui/CardOption";
import React from "react";
import { useTranslation } from "react-i18next";

interface FilterTypeSelectionProps {
  filterType: string;
  setFilterType: React.Dispatch<React.SetStateAction<string>>;
  disabled: boolean;
}

export function FilterTypeSelection({
  filterType,
  setFilterType,
  disabled,
}: FilterTypeSelectionProps) {
  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.basicInformation",
  });

  return (
    <div className="flex flex-col gap-4 p-6">
      <h3 className="text-sm leading-5 font-medium text-primary-light">
        {t("typeSelectionHeader")}
      </h3>
      <div className="grid grid-cols-2 gap-6">
        <button
          disabled={disabled}
          type="button"
          onClick={() => setFilterType("studentFilters")}
        >
          <CardOption
            title={t("studentFilters.title")}
            description={t("studentFilters.description")}
            selected={filterType === "studentFilters"}
          />
        </button>
        <button
          disabled={disabled}
          type="button"
          onClick={() => setFilterType("csvImport")}
        >
          <CardOption
            title={t("csvImport.title")}
            description={t("csvImport.description")}
            selected={filterType === "csvImport"}
          />
        </button>
      </div>
    </div>
  );
}
